<template>
  <div id="global-container">
    <!--ナビゲーション-->
    <nav class="mobile-menu">
      <div class="mobile-menu__main">
        <div class="mobile-menu__item" style="--i: 0">
          <a class="mobile-menu__link" href="#">
            <span class="main-title"
              ><router-link to="/" @click="closemenu">Map</router-link></span
            >
          </a>
          <div id="jp-map">マップ</div>
        </div>
        <div class="mobile-menu__item" style="--i: 1">
          <a class="mobile-menu__link" href="#">
            <span class="main-title">
              <router-link to="/spots/" @click="closemenu">Spots</router-link>
            </span>
          </a>
          <div id="jp-aboutus">地名ごとに見る</div>
        </div>
        <div class="mobile-menu__item" style="--i: 2">
          <a class="mobile-menu__link" href="#">
            <span class="main-title">
              <router-link to="/fish/" @click="closemenu">Fish</router-link>
            </span>
          </a>
          <div id="jp-fish">魚ごとに見る</div>
        </div>
        <div class="mobile-menu__item" style="--i: 3">
          <a class="mobile-menu__link" href="#">
            <span class="main-title"
              ><router-link to="/shop" @click="closemenu"
                >Shop</router-link
              ></span
            >
          </a>
          <div id="jp-mypage">ショップ検索</div>
        </div>
        <div class="mobile-menu__item" style="--i: 4">
          <a class="mobile-menu__link" href="#">
            <span class="main-title">
              <router-link to="/about/" @click="closemenu"
                >About Us</router-link
              >
            </span>
          </a>
          <div id="jp-aboutus">私たちについて</div>
        </div>
        <div class="mobile-menu__others">
          <div class="mobile-menu__item" style="--i: 5">
            <button
              type="button"
              class="mobile-menu__others-button"
              :aria-expanded="isOthersOpen"
              aria-controls="mobile-menu-others"
              @click="isOthersOpen = !isOthersOpen"
            >
              <span class="main-title">
                Others
                <span
                  class="mobile-menu__others-indicator"
                  aria-hidden="true"
                ></span>
              </span>
              <span class="mobile-menu__others-label">その他</span>
            </button>
          </div>
          <div
            id="mobile-menu-others"
            v-show="isOthersOpen"
            class="mobile-menu__others-submenu"
          >
            <div class="mobile-menu__item" style="--i: 6">
              <a class="mobile-menu__link" href="#">
                <span class="main-title"
                  ><router-link to="/login" @click="closemenu"
                    >Log in/Sign up</router-link
                  ></span
                >
              </a>
              <div id="jp-login">ログイン/サインアップ</div>
            </div>
            <div class="mobile-menu__item" style="--i: 7">
              <a class="mobile-menu__link" href="#">
                <span class="main-title"
                  ><router-link to="/mypage" @click="closemenu"
                    >MyPage</router-link
                  ></span
                >
              </a>
              <div id="jp-mypage">マイページ</div>
            </div>
            <div class="mobile-menu__item" style="--i: 8">
              <a class="mobile-menu__link" href="#">
                <span class="main-title"
                  ><router-link to="/PostView" @click="closemenu"
                    >Post</router-link
                  ></span
                >
              </a>
              <div id="jp-post">投稿</div>
            </div>
            <div class="mobile-menu__item" style="--i: 9">
              <a class="mobile-menu__link" href="#">
                <span class="main-title"
                  ><router-link to="/Setting" @click="closemenu"
                    >Setting</router-link
                  ></span
                >
              </a>
              <div id="jp-setting">設定</div>
            </div>
            <div class="mobile-menu__item" style="--i: 10">
              <a class="mobile-menu__link" href="#">
                <span class="main-title">
                  <router-link to="/Contact" @click="closemenu"
                    >Contact</router-link
                  >
                </span>
              </a>
              <div id="jp-contact">お問い合わせ</div>
            </div>
            <div class="mobile-menu__item" style="--i: 11">
              <a class="mobile-menu__link" href="#">
                <span class="main-title">
                  <router-link to="/goods/" @click="closemenu"
                    >Goods</router-link
                  >
                </span>
              </a>
              <div id="jp-aboutus">グッズ</div>
            </div>
            <div class="mobile-menu__item" style="--i: 12">
              <a class="mobile-menu__link" href="#">
                <span class="main-title">
                  <router-link to="/policy/" @click="closemenu"
                    >Policy</router-link
                  >
                </span>
              </a>
              <div id="jp-aboutus">ポリシー</div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!--ナビゲーション-->

    <div id="container">
      <header class="header">
        <div id="header_sub">
          <div>
            <a
              href="https://www.instagram.com/diving_partner?igsh=MWpmbWF0M3Q3ZHZtNQ%3D%3D&utm_source=qr"
              ><img
                class="dinving-logo"
                src="../src/assets/DP_logo.png"
                alt="ダイビングパートナー｜魚から探せるダイビングスポット"
            /></a>
          </div>
          <img
            class="header-name"
            src="../src/assets/header.png"
            alt="header"
          />
        </div>
        <div id="mobile-menu_div">
          <button class="mobile-menu__btn" @click="addEvent">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
      <div id="wave"></div>
      <router-view />
    </div>
  </div>
</template>

<script>
const OTHER_MENU_PATHS = [
  "/login",
  "/mypage",
  "/PostView",
  "/Setting",
  "/Contact",
  "/goods/",
  "/policy/",
]

export default {
  name: "HumburgerMenu",
  data() {
    return { isOthersOpen: false }
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        const normalizedPath = path.replace(/\/+$/, "").toLowerCase()
        this.isOthersOpen = OTHER_MENU_PATHS.some(
          (target) =>
            target.replace(/\/+$/, "").toLowerCase() === normalizedPath
        )
      },
    },
  },
  methods: {
    getEventType() {
      return window.ontouchstart ? "touchstart" : "click"
    },
    toggleMenu() {
      document.querySelector("#global-container").classList.toggle("menu-open")
      console.log("toggleMenu")
    },

    addEvent() {
      this.toggleMenu()
    },
    closemenu() {
      document.querySelector("#global-container").classList.toggle("menu-open")
      console.log("closemenu")
    },
  },
}
</script>

<style>
/* =========================
   menu-open 時のスクロール制御
   - 背景は固定（スクロール不可）
   - メニュー本体だけスクロール可
========================= */

/* 1) 背景スクロールを止める（#global-container 配下を固定） */
.menu-open #container {
  height: 100svh; /* iOS Safari 対策 */
  overflow: hidden;
}

/* 2) メニュー全体は「当たり判定の器」。スクロールはさせない */
.menu-open .mobile-menu {
  overflow: hidden;
}

/* 3) スクロールさせるのはメニューの中身だけ */

/* どのブラウザでも header 画像の潰れを防ぐ基礎 */
.header,
#header_sub {
  align-items: center; /* flex の縦揃えを固定 */
}

.header-name {
  display: block; /* inline 由来のズレを消す */
  width: auto; /* アスペクト比維持 */
  height: auto; /* アスペクト比維持（各 media で上書き） */
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  flex: 0 0 auto; /* flex で縮められにくくする */
  /* padding-left / height の固定値はここには置かない。
     各メディアクエリで個別指定する。 */
}

@media screen and (min-width: 1000px) {
  div,
  img,
  input,
  textarea,
  select,
  button {
    -webkit-appearance: none; /* Safari, Chrome */
    -moz-appearance: none; /* Firefox */
    -ms-appearance: none; /* IE, Edge */
    appearance: none;
    border-radius: 0; /* 必要に応じて角を消す */
    padding: 0; /* デフォルトのパディングをリセット */
    margin: 0; /* デフォルトのマージンをリセット */
  }

  input[type="search"] {
    -webkit-appearance: none; /* iOSの検索フィールド特有のスタイルを無効化 */
    -moz-appearance: none; /* Firefox */
    -ms-appearance: none; /* IE, Edge */
    /*outline-offset: -2px; アウトラインの調整 */
    border-color: #000;
  }

  input:focus {
    outline: none; /* フォーカス時の青い枠を消す */
    border-color: #000; /* カスタムのフォーカス時のボーダーカラーを指定 */
  }

  div {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  button {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;

    font-weight: 800;
  }
  h1 {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  h5 {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  span {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }

  nav {
    padding: 10px, 50px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }

  #container {
    position: relative;
    height: 100vh;

    transition: all 0.5s;
  }

  .header {
    position: relative; /* header-name の absolute 基準 */
    background-color: white;
    height: 100px;
    display: flex;
    align-items: center;
    width: 100%;
  }

  #header_sub {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 16px;
  }

  .dinving-logo {
    width: 161px;
    height: 43px;
    flex-shrink: 0;
  }

  /* PC: header 全体の水平・垂直中央に固定 */
  .header-name {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 50px; /* 994×248 → 幅約200px */
    width: auto;
    object-fit: contain;
    pointer-events: none;
  }

  #wave {
    height: 45px;
    background-image: url(../src/assets/wave2.jpg);
    background-size: 50% 100%;
    animation: 5s 1 wave;
  }
  @keyframes wave {
    0% {
      background-position-x: 0%;
    }

    100% {
      background-position-x: 200%;
    }
  }

  body {
    margin: 0;
  }

  /* メニュー全体（画面全体）は透明。クリック判定用の器 */
  .mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;

    height: 50vh; /* ← 画面の1/4 */
    max-height: 260px; /* 任意：大画面で高くなりすぎ防止 */
    min-height: 120px; /* 任意：小さすぎ防止 */

    background: transparent;
    z-index: 1000;

    pointer-events: none;
    opacity: 0;

    /* 念のため（全画面覆いを防ぐ） */
    bottom: auto;
  }

  .menu-open .mobile-menu {
    display: block;
    pointer-events: auto;
    opacity: 1;
    z-index: 4000;
  }

  /* 中身だけ白、かつ帯の中でスクロールさせる */
  .mobile-menu__main {
    width: 100%;
    height: 100%; /* ← 親(25vh)に追従 */
    background: #fff;

    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    padding: 15px 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);

    overflow-y: auto; /* ← ここでスクロール */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  #mobile-menu_div {
    display: flex;
    opacity: 100%;
    position: fixed; /* relative を消す */
    top: 20px;
    right: 20px;
    z-index: 5000; /* メニューより上 */
  }

  .mobile-menu__btn {
    background-color: unset;

    border: none;
    outline: none !important;
    cursor: pointer;
  }
  .mobile-menu__btn > span {
    background-color: rgb(71, 50, 204);
    width: 35px;
    height: 4px;
    border-radius: 20%;
    display: block;
    margin-bottom: 9px;
    transition: transform 0.7s;
  }
  .mobile-menu__btn > span:first-child {
    background-color: rgb(44, 28, 170);
  }

  .mobile-menu__btn > span:last-child {
    margin-bottom: 0;
    background-color: rgb(98, 82, 216);
  }
  .mobile-menu__cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    visibility: hidden;
    transition: opacity 1s;
    cursor: pointer;
  }

  .mobile-menu__item {
    display: block;
    transform: translate3d(0, 0, -1000px);
    padding: 0 40px;
    transition: transform 0.3s, opacity 0.2s;
    opacity: 0;
    transition-delay: calc(var(--i) * 70ms);
  }

  .mobile-menu__link {
    display: block;
    margin-top: 30px;
    color: black;
    text-decoration: none;
  }

  /*OPEN*/

  /*.menu-open #container {
  transform: translate(-300px, 60px);
  box-shadow: 0 8px 40px -10px rgba(0, 0, 0, 0.8);
}
*/
  .menu-open .diving-logo {
    z-index: 1;
  }
  .menu-open .header-name {
    z-index: 1;
  }
  .menu-open #wave {
    z-index: 1;
  }
  .menu-open .mobile-menu_div {
    z-index: 9999;
  }
  .menu-open .mobile-menu {
    pointer-events: auto; /* 開いたらクリックを受ける */
    opacity: 1;
    z-index: 4000;
  }
  .menu-open .mobile-menu__cover {
    opacity: 10%;
    visibility: visible;
  }

  .menu-open .mobile-menu__item {
    transform: none;
    opacity: 1;
  }
  /* .menu-open .mobile-menu__item:nth-child(1) {
    transition-delay: 0.07s;
  }
  .menu-open .mobile-menu__item:nth-child(2) {
    transition-delay: 0.14s;
  }
  .menu-open .mobile-menu__item:nth-child(3) {
    transition-delay: 0.21s;
  }
  .menu-open .mobile-menu__item:nth-child(4) {
    transition-delay: 0.28s;
  }
  .menu-open .mobile-menu__item:nth-child(5) {
    transition-delay: 0.35s;
  }*/
  .menu-open .mobile-menu__btn {
    z-index: 50;
  }
  .menu-open .mobile-menu__btn > span {
    background-color: black;
  }
  .menu-open .mobile-menu__btn > span:nth-child(1) {
    transition-delay: 70ms;
    transform: translateY(11px) rotate(135deg);
    background: linear-gradient(to right, #3731f5, #6557fe);
  }
  .menu-open .mobile-menu__btn > span:nth-child(2) {
    transition-delay: 0s;
    transform: translateX(-18px) scaleX(0);
  }
  .menu-open .mobile-menu__btn > span:nth-child(3) {
    transition-delay: 140ms;
    transform: translateY(-11px) rotate(-135deg);
    background: linear-gradient(to left, #3731f5, #6557fe);
  }

  .menu-open .mobile-menu__item > .jp-title {
    font-size: 1px;
  }
  /*OPEN*/
  .main-title {
    font-weight: 600;
    font-size: 25px;
  }

  .sub-title {
    display: block;
    font-size: 14px;
    color: #535353;
  }
  #jp-map {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-login {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-mypage {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-post {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-setting {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-contact {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-aboutus {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-fish {
    font-size: 10px;
    margin-top: 10px;
  }
}
@media screen and (min-width: 720px) and (max-width: 1000px) {
  div,
  img,
  input,
  textarea,
  select,
  button {
    -webkit-appearance: none; /* Safari, Chrome */
    -moz-appearance: none; /* Firefox */
    -ms-appearance: none; /* IE, Edge */
    appearance: none;
    border-radius: 0; /* 必要に応じて角を消す */
    padding: 0; /* デフォルトのパディングをリセット */
    margin: 0; /* デフォルトのマージンをリセット */
  }

  input[type="search"] {
    -webkit-appearance: none; /* iOSの検索フィールド特有のスタイルを無効化 */
    -moz-appearance: none; /* Firefox */
    -ms-appearance: none; /* IE, Edge */
    /*outline-offset: -2px; アウトラインの調整 */
    border-color: #000;
  }

  input:focus {
    outline: none; /* フォーカス時の青い枠を消す */
    border-color: #000; /* カスタムのフォーカス時のボーダーカラーを指定 */
  }
  div {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  button {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;

    font-weight: 800;
  }
  h1 {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  h5 {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  span {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }

  #container {
    position: relative;
    height: 100vh;

    transition: all 0.5s;
  }

  .header {
    position: relative;
    background-color: white;
    height: 100px;
    display: flex;
    align-items: center;
    width: 100%;
  }

  #header_sub {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 16px;
  }

  .dinving-logo {
    width: 161px;
    height: 43px;
    flex-shrink: 0;
  }

  /* タブレット: header 全体の水平・垂直中央に固定 */
  .header-name {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 44px;
    width: auto;
    object-fit: contain;
    pointer-events: none;
  }

  #wave {
    height: 45px;
    background-image: url(../src/assets/wave2.jpg);
    background-size: 50% 100%;
    animation: 5s 1 wave;
  }
  @keyframes wave {
    0% {
      background-position-x: 0%;
    }

    100% {
      background-position-x: 200%;
    }
  }

  body {
    margin: 0;
  }

  /* メニュー全体（画面全体）は透明。クリック判定用の器 */
  .mobile-menu {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: none;
    background: transparent; /* ←ここが重要 */
    padding: 0 !important; /* nav{padding:30px} を確実に潰す */
  }

  .menu-open .mobile-menu {
    display: block;
    z-index: 4000;
  }

  /* 白くしたいのは中身だけ */
  .mobile-menu__main {
    background: #fff; /* ←ここが要件 */
    /* 任意：見た目 */
    border-radius: 16px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);

    /* 任意：配置（例：右上から出す/中央にする等に合わせて調整） */
    width: min(900px, 92vw);
    margin: 90px auto 0; /* 上に余白、中央寄せ */
    padding: 24px;
  }

  #mobile-menu_div {
    display: flex;
    opacity: 100%;
    position: fixed; /* relative を消す */
    top: 20px;
    right: 20px;
    z-index: 5000; /* メニューより上 */
  }
  .mobile-menu__btn {
    background-color: unset;

    border: none;
    outline: none !important;
    cursor: pointer;
  }
  .mobile-menu__btn > span {
    background-color: rgb(71, 50, 204);
    width: 35px;
    height: 4px;
    border-radius: 20%;
    display: block;
    margin-bottom: 9px;
    transition: transform 0.7s;
  }
  .mobile-menu__btn > span:first-child {
    background-color: rgb(44, 28, 170);
  }

  .mobile-menu__btn > span:last-child {
    margin-bottom: 0;
    background-color: rgb(98, 82, 216);
  }
  .mobile-menu__cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    visibility: hidden;
    transition: opacity 1s;
    cursor: pointer;
  }

  .mobile-menu__item {
    display: block;
    transform: translate3d(0, 0, -1000px);
    padding: 0 40px;
    transition: transform 0.3s, opacity 0.2s;
    opacity: 0;
    transition-delay: calc(var(--i) * 70ms);
  }

  .mobile-menu__link {
    display: block;
    margin-top: 30px;
    color: black;
    text-decoration: none;
  }

  /*OPEN*/

  /*.menu-open #container {
  transform: translate(-300px, 60px);
  box-shadow: 0 8px 40px -10px rgba(0, 0, 0, 0.8);
}
*/
  .menu-open .diving-logo {
    z-index: 1;
  }
  .menu-open .header-name {
    z-index: 1;
  }
  .menu-open #wave {
    z-index: 1;
  }
  .menu-open .mobile-menu_div {
    z-index: 9999;
  }
  .menu-open .mobile-menu {
    border: solid thin;
    z-index: 4000;
  }
  .menu-open .mobile-menu__cover {
    opacity: 10%;
    visibility: visible;
  }

  .menu-open .mobile-menu__item {
    transform: none;
    opacity: 1;
  }
  .menu-open .mobile-menu__item:nth-child(1) {
    transition-delay: 0.07s;
  }
  .menu-open .mobile-menu__item:nth-child(2) {
    transition-delay: 0.14s;
  }
  .menu-open .mobile-menu__item:nth-child(3) {
    transition-delay: 0.21s;
  }
  .menu-open .mobile-menu__item:nth-child(4) {
    transition-delay: 0.28s;
  }
  .menu-open .mobile-menu__item:nth-child(5) {
    transition-delay: 0.35s;
  }
  .menu-open .mobile-menu__btn {
    z-index: 50;
  }
  .menu-open .mobile-menu__btn > span {
    background-color: black;
  }
  .menu-open .mobile-menu__btn > span:nth-child(1) {
    transition-delay: 70ms;
    transform: translateY(11px) rotate(135deg);
    background: linear-gradient(to right, #3731f5, #6557fe);
  }
  .menu-open .mobile-menu__btn > span:nth-child(2) {
    transition-delay: 0s;
    transform: translateX(-18px) scaleX(0);
  }
  .menu-open .mobile-menu__btn > span:nth-child(3) {
    transition-delay: 140ms;
    transform: translateY(-11px) rotate(-135deg);
    background: linear-gradient(to left, #3731f5, #6557fe);
  }

  .menu-open .mobile-menu__item > .jp-title {
    font-size: 1px;
  }
  /*OPEN*/
  .main-title {
    font-weight: 600;
    font-size: 25px;
  }

  .sub-title {
    display: block;
    font-size: 14px;
    color: #535353;
  }
  #jp-map {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-login {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-mypage {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-post {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-setting {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-contact {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-aboutus {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-fish {
    font-size: 10px;
    margin-top: 10px;
  }
}
@media screen and (max-width: 720px) {
  #global-container {
    min-height: 100svh;
    width: 100%; /* 固定430pxをやめて画面幅に追従 */
    overflow-x: hidden;
  }
  div,
  img,
  input,
  textarea,
  select,
  button {
    -webkit-appearance: none; /* Safari, Chrome */
    -moz-appearance: none; /* Firefox */
    -ms-appearance: none; /* IE, Edge */
    appearance: none;
    border-radius: 0; /* 必要に応じて角を消す */
    padding: 0; /* デフォルトのパディングをリセット */
    margin: 0; /* デフォルトのマージンをリセット */
  }

  input[type="search"] {
    -webkit-appearance: none; /* iOSの検索フィールド特有のスタイルを無効化 */
    -moz-appearance: none; /* Firefox */
    -ms-appearance: none; /* IE, Edge */
    /*outline-offset: -2px; アウトラインの調整 */
    border-color: #000;
  }

  input:focus {
    outline: none; /* フォーカス時の青い枠を消す */
    border-color: #000; /* カスタムのフォーカス時のボーダーカラーを指定 */
  }

  #app {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
  }
  div {
    /*font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;*/
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 600;
  }
  button {
    /*font-family: Helvetica, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic",
      sans-serif;*/
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    /* font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;*/
    font-weight: 500;
  }
  h1 {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  h5 {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }
  span {
    font-family: Helvetica, "小塚ゴシック Pro", "Kozuka Gothic Pro", sans-serif;
    font-weight: 800;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }

  #container {
    position: relative;
    height: 100vh;

    transition: all 0.5s;
  }

  .header {
    position: relative; /* header-name の absolute 基準 */
    background-color: white;
    height: 52px;
    display: flex;
    align-items: center;
    width: 100%;
  }

  #header_sub {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 12px;
  }

  .dinving-logo {
    width: 80px;
    height: 22px;
    flex-shrink: 0;
  }

  /*
   * header-name を absolute で header の真ん中に固定。
   * left:50% + translateX(-50%) で水平中央、
   * top:50%  + translateY(-50%) で垂直中央。
   * インスタロゴ・ハンバーガー両方の影響を受けない。
   */
  .header-name {
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    height: 26px !important;
    width: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    object-fit: contain;
    pointer-events: none;
  }

  #wave {
    height: 45px;
    background-image: url(../src/assets/wave2.jpg);
    background-size: 50% 100%;
    animation: 5s 1 wave;
  }
  @keyframes wave {
    0% {
      background-position-x: 0%;
    }

    100% {
      background-position-x: 200%;
    }
  }

  body {
    margin: 0;
  }

  /* ① 画面全体の器（透明・当たり判定用） */
  .mobile-menu {
    position: fixed;
    inset: 0;
    background: transparent;
    z-index: 1000;
    pointer-events: none; /* 閉じてる時はクリックを吸わない */
    opacity: 0; /* 閉じてる時は見えない */
    display: block; /* 念のため（nav要素はblockだが明示しておく） */
  }

  .menu-open .mobile-menu {
    z-index: 4000;
    opacity: 1;
    pointer-events: auto;
  }
  /* ② 右側に出る実体パネル（30%） */
  .mobile-menu__main {
    position: absolute;
    top: 0;
    right: 0;

    width: 28vw; /* ← 画面の30% */
    /*min-width: 260px; /* ← 狭すぎ防止（任意） */
    /*max-width: 320px; /* ← 太くなりすぎ防止（任意） */

    height: 100vh;
    background: #fff;

    padding: 20px 16px;
    box-shadow: -12px 0 32px rgba(0, 0, 0, 0.18);

    /* 初期状態：閉じている */
    transform: translateX(100%);
    transition: transform 0.35s ease;

    height: 100svh; /* iOS Safari 対策 */
    box-sizing: border-box; /* padding込みで高さ計算 */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain; /* 背景への伝播を止める */
  }
  .menu-open #container {
    height: 100svh;
    overflow: hidden;
    touch-action: none; /* iOS Safari でのタッチ操作を抑制 */
  }
  /* ボタンは常に最前面 */
  #mobile-menu_div {
    position: fixed;
    top: 18px;
    right: 12px;
    z-index: 5000;
  }

  .mobile-menu__btn {
    background-color: unset;

    border: none;
    outline: none !important;
    cursor: pointer;
  }
  .mobile-menu__btn > span {
    background-color: rgb(71, 50, 204);
    width: 35px;
    height: 4px;
    border-radius: 20%;
    display: block;
    margin-bottom: 9px;
    transition: transform 0.7s;
  }
  .mobile-menu__btn > span:first-child {
    background-color: rgb(44, 28, 170);
  }

  .mobile-menu__btn > span:last-child {
    margin-bottom: 0;
    background-color: rgb(98, 82, 216);
  }
  .mobile-menu__cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    visibility: hidden;
    transition: opacity 1s;
    cursor: pointer;
  }

  .mobile-menu__item {
    display: block;
    transform: translate3d(0, 0, -1000px);
    transition: transform 0.3s, opacity 0.2s;
    opacity: 0;
    opacity: 0;
    transform: translateX(24px); /* 右から出す */
    transition: transform 0.35s ease, opacity 0.25s ease;
    transition-delay: calc(var(--i) * 60ms);
  }

  .mobile-menu__link {
    display: block;
    margin-top: 30px;
    color: black;
    text-decoration: none;
  }

  /*OPEN*/

  /*.menu-open #container {
  transform: translate(-300px, 60px);
  box-shadow: 0 8px 40px -10px rgba(0, 0, 0, 0.8);
}
*/
  .menu-open .diving-logo {
    z-index: 1;
  }
  .menu-open .header-name {
    z-index: 1;
  }
  .menu-open #wave {
    z-index: 1;
  }
  .menu-open .mobile-menu_div {
    z-index: 9999;
  }
  .menu-open .mobile-menu {
    border: solid thin;
    z-index: 4000;
  }
  /* ③ menu-open 時にスライドイン */
  .menu-open .mobile-menu__main {
    transform: translateX(0);
  }
  .menu-open .mobile-menu__cover {
    opacity: 10%;
    visibility: visible;
  }

  .menu-open .mobile-menu__item {
    transform: translateX(0);
    opacity: 1;
  }

  .menu-open .mobile-menu__btn {
    z-index: 50;
  }
  .menu-open .mobile-menu__btn > span {
    background-color: black;
  }
  .menu-open .mobile-menu__btn > span:nth-child(1) {
    transition-delay: 70ms;
    transform: translateY(11px) rotate(135deg);
    background: linear-gradient(to right, #3731f5, #6557fe);
  }
  .menu-open .mobile-menu__btn > span:nth-child(2) {
    transition-delay: 0s;
    transform: translateX(-18px) scaleX(0);
  }
  .menu-open .mobile-menu__btn > span:nth-child(3) {
    transition-delay: 140ms;
    transform: translateY(-11px) rotate(-135deg);
    background: linear-gradient(to left, #3731f5, #6557fe);
  }

  .menu-open .mobile-menu__item > .jp-title {
    font-size: 1px;
  }
  /*OPEN*/
  .main-title {
    font-weight: 600;
    font-size: 16px;
  }

  .sub-title {
    display: block;
    font-size: 14px;
    color: #535353;
  }
  #jp-map {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-login {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-mypage {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-post {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-setting {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-contact {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-aboutus {
    font-size: 10px;
    margin-top: 10px;
  }
  #jp-fish {
    font-size: 10px;
    margin-top: 10px;
  }
}

/* Keep the shared panel scrollable after expanding Others at every width. */
.mobile-menu__main {
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
  align-content: flex-start;
}

.mobile-menu__item {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
}

.mobile-menu__others {
  flex: 0 0 100%;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.mobile-menu__others-button {
  display: block;
  max-width: 100%;
  margin: 30px 0 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2c3e50;
  font: inherit;
  text-align: inherit;
  cursor: pointer;
}

.mobile-menu__others-button .main-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
}

.mobile-menu__others-label {
  display: block;
  margin-top: 10px;
  font-size: 10px;
  font-weight: inherit;
}

.mobile-menu__others-button:focus-visible {
  outline: 2px solid #3731f5;
  outline-offset: 4px;
}

.mobile-menu__others-indicator {
  display: inline-block;
  flex: 0 0 auto;
  width: 6px;
  height: 6px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: translateY(-2px) rotate(45deg);
  transition: transform 0.2s ease;
}

.mobile-menu__others-button[aria-expanded="true"]
  .mobile-menu__others-indicator {
  transform: translateY(2px) rotate(225deg);
}

.mobile-menu__others-submenu {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  padding-left: 8px;
  border-left: 1px solid #d5d9e2;
}

/* Override the older nth-child delays after nesting the seven links. */
.menu-open .mobile-menu .mobile-menu__item {
  transition-delay: calc(var(--i) * 70ms);
}

@media screen and (min-width: 720.01px) and (max-width: 1000px) {
  .mobile-menu__main {
    max-height: calc(100svh - 90px);
    overflow-y: auto;
  }
}

@media screen and (max-width: 720px) {
  .menu-open .mobile-menu .mobile-menu__item {
    transition-delay: calc(var(--i) * 60ms);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-menu__others-indicator {
    transition: none;
  }
}

@media screen and (min-width: 1000px) {
  .mobile-menu__main {
    margin-top: 0;
  }

  .mobile-menu__others {
    display: contents;
  }

  .mobile-menu__others-submenu {
    display: flex;
    flex: 0 0 100%;
    flex-wrap: wrap;
    gap: 12px;
    padding-left: 0;
    border-left: 0;
    border-top: 1px solid #d5d9e2;
  }
}
</style>
